<div class="row alert-banner">
	<lib-alert-banner *ngIf="isCreateMode"
	                  [alertType]="'tier3'"
	                  [hidden]="alertMessages.length === 0"
	                  [maxWidth]="'100%'"
	                  [messageList]="alertMessages"></lib-alert-banner>
	<ng-container *ngFor="let error of errorMessages">
		<lib-alert-banner [alertType]="'error'"
		                  [hidden]="error===''"
		                  [maxWidth]="'100%'"
		                  [message]="error"></lib-alert-banner>
	</ng-container>
</div>
<lib-universal-id-details [currentEnterpriseId]="enterpriseId"
                          [enterpriseLabels]="enterpriseLabels"
                          [selectedAccounts]="selectedAccounts"
                          [ssoUserDetails]="ssoUserDetails"
                          [isCreateMode]="isCreateMode"
                          [isCreateModeUniversalIdFlow]="isCreateModeUniversalIdFlow"
                          [triggerAutopopulate]="triggerAutopopulate"
                          [idpAttributes]="idpAttributes"
                          [identityBrokeringPolicy]="identityBrokeringPolicy"
                          (universalIdDetailsFormUpdated)="universalIdDetailsFormUpdated($event)"/>
